import 'bootstrap/dist/css/bootstrap.min.css';
import Button from "@material-ui/core/Button";
import OrderCard from "./fragments/OrderCard";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrders, selectOrders } from "../../redux/slices/orders";
import { nanoid } from "@reduxjs/toolkit";
import { LinearProgress } from "@material-ui/core";
import { STATUS_PENDING } from "../../constants";
import Subheader from "./fragments/Subheader.Orders";
import { useState } from "react";
import DetailModal from "./fragments/DetailModal";
import { Row } from "react-bootstrap";
import { Alert } from "@material-ui/lab";
import { getCurrentINShippingOrders, getActivePurchaseOrders } from 'src/redux/slices/inventory/inventory.thunks'

let isInitialized = false

export default function Orders() {
    const [selected, setSelected] = useState(null)
    const [open, setOpen] = useState(false)
    const { orders, status, snapshot: { noMoreResult, filter } } = useSelector(selectOrders)
    const dispatch = useDispatch();

    if (!isInitialized) {
        dispatch(fetchOrders({ forceForCurrentUser: true }))
        dispatch(getCurrentINShippingOrders())
        dispatch(getActivePurchaseOrders())

        isInitialized = true
    }

    const handleLoadMore = () => {
        dispatch(fetchOrders({ filter: filter }))
    }

    const handleDetailModalOpening = (detail) => {
        setSelected(detail)
        setOpen(true)
    }

    const handleDetailModalClosing = () => {
        setOpen(false)
        setSelected(null)
    }

    return (
        <main>
            <Subheader />

            <section className='mt-4'>

                {
                    orders && orders.length !== 0 && (
                        <Alert severity="info" className='mb-3'>
                            Double cliquer pour voir les details de la commande
                        </Alert>
                    )
                }

                {
                    orders && orders.map(order => (
                        <OrderCard key={nanoid()} item={order} onClick={() => handleDetailModalOpening(order)} />
                    ))
                }

                {
                    noMoreResult && orders.length === 0 && (
                        <Row style={{ display: 'grid', placeItems: 'center' }}>
                            <Alert severity="info">Aucun résultat</Alert>
                        </Row>
                    )
                }

            </section>

            {
                status === STATUS_PENDING && (
                    <section className='pl-5 pr-5'>
                        <LinearProgress />
                    </section>
                )
            }


            {
                !noMoreResult && (
                    <section style={{ display: 'grid', placeItems: 'center', paddingTop: 20 }}>
                        <Button variant='contained' color='primary' disabled={status === STATUS_PENDING}
                            onClick={handleLoadMore}>
                            Charger plus
                        </Button>
                    </section>
                )
            }

            {
                selected && (
                    <DetailModal open={open} detail={selected} onClose={handleDetailModalClosing} />
                )
            }

        </main>
    )
}